module.exports = __webpack_public_path__ + "static/media/after_desert.ac6038c4.mp3";